import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { HttpInterceptor } from '../interceptors/http-interceptor.service';
import { AuthenticatedWebService } from './authenticated.web.service';
import { OAuthService } from '../../pages/user/services/oauth.service';

@Injectable()
export class CardService extends AuthenticatedWebService {
  constructor(
    private http: HttpInterceptor,
    oauthService: OAuthService
  ) {
    super(oauthService);
  }

  getCards(organizationId: string, sellerId: string, params?: HttpParams): Observable<any> {
     const url = environment.api.base_api_v2 + `organizations/${organizationId}/sellers/${sellerId}/cards`;

    return this.http.get(url, { headers: this.httpHeaders, params }).pipe(map((res: any) => res));
  }

  createCardToken(organizationId: string, sellerId: string, cardData: any): Observable<any> {
    const url = environment.api.base_api_v2 + `organizations/${organizationId}/sellers/${sellerId}/cards`;

    return this.http.post(url, cardData, { headers: this.httpHeaders}).pipe(map((res: any) => res));
  }

  setDefaultCard(organizationId: string, sellerId: string, cardTokenId: string): Observable<any> {
    const url = environment.api.base_api_v2 + `organizations/${organizationId}/sellers/${sellerId}/cards/${cardTokenId}/set-default-card`;

    return this.http.put(url, null, { headers: this.httpHeaders}).pipe(map((res: any) => res));
  }
}

